import { FormInput } from '@dx-ui/osc-form';
import { Text } from '@dx-ui/global-ui-prism';
import { useTranslation } from 'next-i18next';
import { TermsQuery } from './queries/generated/types';
import type { Term } from '@dx-ui/gql-types';

type PersonalDataProps = {
  termsData: TermsQuery;
  isLoadingTerms: boolean;
};

export const PersonalData = ({ termsData, isLoadingTerms }: PersonalDataProps) => {
  return !isLoadingTerms
    ? termsData?.terms?.map((term) => (
        <TermInput key={term._id} termId={term.termId} description={term.description} />
      ))
    : null;
};

export type TermInput =
  | 'TERM-PIPL-DATA-COLLECTION'
  | 'TERM-PIPL-DATA-SHARE'
  | 'TERM-PIPL-DATA-TRANSFER';

const TermInput = ({ termId, description }: Pick<Term, 'termId' | 'description'>) => {
  const [t] = useTranslation('osc-join-form-join');

  return (
    <>
      <FormInput
        name={termId}
        label={t(`${termId as TermInput}.label`)}
        type="checkbox"
        labelClassName="w-full"
        aria-describedby={termId}
        enableInlineError={false}
        registerOptions={{
          validate: (value: string) => {
            if (!value) {
              return t(`${termId as TermInput}.label`);
            }
          },
        }}
      />
      <Text size="sm" id={termId} className="!mt-0 ms-8">
        {description ?? ''}
      </Text>
    </>
  );
};
